export default "__VITE_ASSET__nuAeGmlx__"